export default __webpack_public_path__ + "static/media/53-min.fc082972.png";